// One export affordance shared by every dashboard widget so the CSV
// button reads the same everywhere: a small default-style button with
// the download glyph. Pass onClick + disabled; extra props (e.g.
// data-testid) flow through to the underlying Button.
import React from 'react'
import { IconDownload } from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

export const ExportCsvButton = ({ onClick, disabled, label = 'Export CSV', ...props }) => (
  <Button
    small
    icon={<IconDownload />}
    onClick={onClick}
    disabled={disabled}
    tooltip="Download as CSV"
    {...props}
  >
    {label}
  </Button>
)
